import { invoicePayments } from '../invoicePayment'
import { describeTable } from './describeTable'

describeTable(invoicePayments, {
  description: `One bank payment (suoritus) matched to an invoice, imported by staff from the bank's KTL reference-payment file. Matching is by reference_number = invoices.reference_number; archive_id is the bank's transaction id and keeps re-imports idempotent.
Only bank transfers live here. Card and payment-link payments settle through Stripe and set invoices.status='paid' WITHOUT creating a row, so a paid invoice with zero payments is normal and sum(amount) understates cash received. Never derive "paid" from this table alone — use invoices.status. Partial payments and overpayments both appear as-is; the invoice flips to paid once the sum reaches total_amount.
paid_at is the bank's payment date and is the right anchor for cash-flow (kassavirta) analysis; created_at / imported_at is only when someone ran the import.`,
  columns: {
    amount:
      'Euros received, gross (the customer pays the VAT-inclusive total).',
    paidAt: 'Payment date from the bank file — the cash-flow anchor.',
    archiveId:
      'Bank archive id, unique per transaction; the idempotency key of the import.',
    referenceNumber:
      'The viitenumero the payer used; normally equals invoices.reference_number.',
    payerName: 'Payer name as the bank reports it, truncated to 12 characters.',
    importedAt: 'When the KTL file was imported, not when the money arrived.',
    importedByUserId: 'Staff member who ran the import.',
  },
})
